import SensesBox from './SensesBox';

export default SensesBox;
export { SensesBox };
